
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Translate from "../translate/Translate";

import MainTopNav from "./MainTopNav";
import MainFooter from "./MainFooter";

import hex from "../static/history-hex.png";

class MainDisclaimer extends Component {

    render() {
        return (
            <div className="searchJob-container">
                <div className="static-banner-history">
                    <MainTopNav />
                    <div className="jobSearch-title"><Translate id="main.footer1" /></div>
                </div>
                <div className="history-main">
                    <div className="history-title"><Translate id="footer.disclaimer.subtitle1" /></div>
                    <div className="history-description"><Translate id="footer.disclaimer.section1" /></div>

                    <div className="history-title"><Translate id="footer.disclaimer.subtitle2" /></div>
                    <div className="history-description">
                        <div><Translate id="footer.disclaimer.section2.0" /></div>
                        <div><Translate id="footer.disclaimer.section2.1" /></div>
                        <div><Translate id="footer.disclaimer.section2.2" /></div>
                        <div><Translate id="footer.disclaimer.section2.3" /></div>
                        <div><Translate id="footer.disclaimer.section2.4" /></div>
                        <div><Translate id="footer.disclaimer.section2.5" /></div>
                        <div><Translate id="footer.disclaimer.section2.6" /></div>
                        <div><Translate id="footer.disclaimer.section2.7" /></div>
                        <div><Translate id="footer.disclaimer.section2.8" /></div>
                    </div>
                </div>
                <MainFooter />
            </div>


        )
    }
}

const mapStateToProps = state => ({
    language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {

        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MainDisclaimer);

